export const editMutations = <const>{
	ND_OBJEDNAVKA_ZAKAZKA_SELECT_MAPPER: 'ND_OBJEDNAVKA_ZAKAZKA_SELECT_MAPPER',
	ND_OBJEDNAVKA_OZAKAZKA_SELECT_MAPPER: 'ND_OBJEDNAVKA_OZAKAZKA_SELECT_MAPPER',
	ND_OBJEDNAVKA_SKLAD_SELECT_MAPPER: 'ND_OBJEDNAVKA_SKLAD_SELECT_MAPPER',
	ND_OBJEDNAVKA_ND_SKLAD_SELECT_MAPPER: 'ND_OBJEDNAVKA_ND_SKLAD_SELECT_MAPPER',
	CREATE_KONTROLA_ND_MAPPER: 'kontrolaCenik',
};

export interface HromadnaObjednavka {
	MioPzn?: number,
	MnozstviObj?: number,
	NdNr: string,
	SkladOzn?: string,
	VyrobekndOzn: string,
	ZakazkaId: number | null,
	ZakazkandextodpisId?: number,
	HromadnaObjednavkaRowId: string,
}
